import { useParams } from "react-router-dom";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useDatasetTableFQNs = (includeCustomerEnv = true, id?: string) => {
  const { datasetId = id } = useParams();
  const { data, ...rest } = useFetcher<string[]>(
    `${VITE_CATALOG_API}/datasets/${datasetId}/table-fqns`
  );

  return {
    data: data?.map((fqn) => {
      if (!includeCustomerEnv) {
        // Strip off prepended `snowflake.<customer_env>.`
        const segments = fqn.split(".");
        return segments.slice(2).join(".");
      }
      return fqn;
    }),
    ...rest,
  };
};

export default useDatasetTableFQNs;
